import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import PraiseLogo from "@/components/PraiseLogo";
import heroBg from "@/assets/hero-bg.jpg";

interface FrameHeroProps {
  isLoggedIn: boolean;
}

export const FrameHero = ({ isLoggedIn }: FrameHeroProps) => {
  return (
    <section className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 pointer-events-none">
        <img src={heroBg} alt="" fetchPriority="high" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/40 to-background" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="flex justify-center mb-8"
        >
          <PraiseLogo size={56} />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.6 }}
          className="font-editorial text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-foreground leading-[0.95] mb-6"
        >
          Your praise is<br />
          <span className="gradient-brand-text">dormant.</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          className="text-lg sm:text-xl md:text-2xl text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed"
        >
          Paste one testimonial. Get ready-to-post content for every platform.
          <br className="hidden sm:block" />
          <span className="text-foreground font-medium">60 seconds. No formatting. No rewriting.</span>
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.45, duration: 0.5 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Link to={isLoggedIn ? "/agent" : "/auth"}>
            <Button size="lg" className="gradient-brand text-white text-lg px-10 py-6 shadow-brand hover:opacity-90 transition-opacity">
              Start Extracting
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="mt-6 text-sm text-muted-foreground"
        >
          3 free extractions. No credit card.
        </motion.p>
      </div>
    </section>
  );
};
